import http from 'services/http-service';

const ProgramService = {
    GetFeatured() {
        var response = http.get("/programs/featured");
        return response;
    },

    GetProgramDiscover() {
        var response = http.get(`/programs/discover`);
        return response;
    },

    GetProgram(id: string) {
        var response = http.get(`/programs/${id}`);
        return response;
    }
};

export default ProgramService;